export default {
    illiterate : 'بی‌سواد',
    primarySchool : 'دبستان',
    primary_school : 'دبستان',
    middleSchool : 'راهنمایی',
    middle_school : 'راهنمایی',
    diploma : ' دیپلم',
    associate : 'فوق دیپلم',
    bachelor : ' لیسانس',
    master : 'فوق لیسانس',
    doctoral : ' دکتری',
    postDoctoral : ' فوق دکترا ',
    post_doctoral : ' فوق دکترا ',
}